import { useDispatch } from 'react-redux';
import { setUpdateReduxData } from 'utils/redux/reducers/updateDataReducer';
import { setConfirmationPopup } from 'utils/redux/reducers/confirmationPopupReducer';

export const usePopupMessage = () => {
	const dispatch = useDispatch();

	const sendPopUpMessage = (type: string, message: string, updateRedux: boolean = true) => {
		if (updateRedux) {
			dispatch(setUpdateReduxData(true)); //TODO: Need to determine if this is actually needed
		}
		dispatch(
			setConfirmationPopup({
				isOpen: true,
				result: {
					type: type,
					message: message,
				},
			})
		);
	};

	return sendPopUpMessage;
};
